export const BRAND = {
  name: "Aarmira Supernaturals",
  tagline: "Nature's Power, Your Wellness",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_aarmira-wellness/artifacts/l21xd266_Aarmira%20supernaturals%20final%20logo.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/e8c664d7-d8a0-4fa5-bb1b-aea3a7191ee4/images/c589b125ee2d1f1c89ec4b5ce6fc629df14b5b3c305ce2b2085fb94b1da4face.jpeg",
  bannerBg: "https://images.unsplash.com/photo-1696937525057-efcb5dbc84e3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const WHATSAPP_NUMBER = "919355662555";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi, I need help with my order.")}`;

export const CATEGORY_IMAGES = {
  juices: "https://images.pexels.com/photos/10895942/pexels-photo-10895942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  supplements: "https://images.unsplash.com/photo-1664956618021-73c47736845e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  soaps: "https://images.pexels.com/photos/3735152/pexels-photo-3735152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  shampoo: "https://images.unsplash.com/photo-1747098393451-6b985f62a2c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  skincare: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  wellness: "https://images.unsplash.com/photo-1758525732480-8df43412b54c?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
};
